/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/
import {SettlementDetailSectionsConfigurationService} from './settlement-detail-sections-configuration.service';
import {SettlementDetailModel} from '../../models/settlement-detail/settlement-detail.model';
import {SettlementDetailComponentsModel} from './models/settlement-detail-components.model';
import {SettlementDisplayComponentsTypeEnum} from './models/settlement-display-components-type.enum';
import {Injectable} from '@angular/core';
import SETTLEMENT_DISPLAY_CONFIGURATION_CONSTANTS from './settlement-display-constants';
import {AvailableActions} from '../../api/contracts/available-actions.enum';

@Injectable({
    providedIn: 'root'
})
export class SettlementDisplayConfigurationService {

    constructor(private settlementDetail: SettlementDetailSectionsConfigurationService) {
    }

    retrieveSettlementDisplayConfiguration(settlementDetail: SettlementDetailModel): SettlementDetailComponentsModel[] {
        let configuration: SettlementDetailComponentsModel[] = [];

        configuration = this.retrieveSettlementDetailDisplayConfiguration(settlementDetail);

        return configuration;
    }

    private retrieveSettlementDetailDisplayConfiguration(settlementDetail: SettlementDetailModel): SettlementDetailComponentsModel[] {
        const detail = this.settlementDetail.retrievesSettlementDetailSectionsConfiguration(settlementDetail);
        const configuration: SettlementDetailComponentsModel[] = [];

        // Header
        configuration.push({type: SettlementDisplayComponentsTypeEnum.HEADER, data: detail.header});

        // Body -> Information
        configuration.push({type: SettlementDisplayComponentsTypeEnum.INFORMATION, data: detail.information});

        // Section Title
        configuration.push({
            type: SettlementDisplayComponentsTypeEnum.SECTION_TITLE,
            data: SETTLEMENT_DISPLAY_CONFIGURATION_CONSTANTS.title.agreement
        });

        // Agreement
        configuration.push({type: SettlementDisplayComponentsTypeEnum.AGREEMENT, data: detail.agreement});

        // Footer
        if (settlementDetail.availableActions?.includes(AvailableActions.ACCEPT)
                || settlementDetail.availableActions?.includes(AvailableActions.REJECT)) {
            configuration.push({type: SettlementDisplayComponentsTypeEnum.FOOTER, data: detail.footer});
        }

        return configuration;
    }
}
